import {useEffect} from "preact/compat";
import store from "./store";
import designService from "./service/designService";
import $ from "jquery";
import * as actions from "./actions";
import {showChangedByPos} from "./util";
import Renderer from "./canvas/renderer";
import qrCodeService from "./service/qrCodeService";
import constants from "./constants";

export default function InUsePing() {

  function sendPing() {
    // @ts-ignore
    const {memberNameAbbreviation, id} = window['data']?.member;
    const designId = store.getState().designId;

    if (designId && memberNameAbbreviation && id) {
      designService.designPing(designId, memberNameAbbreviation, id).then(() => {
      });
    }
  }

  // async function sendDsaPing() {
  //   const state = store.getState();
  //   const designId = state.designId;
  //
  //   if (state.dsaAutoSyncEnabled) {
  //     await designService.updateDesignHtml({
  //       id: designId,
  //       html: Renderer.getPagesContent(),
  //       hasVideo: store.getState().hasVideo
  //     });
  //     await qrCodeService.createOrUpdateShareLink(designId, constants.SL_TYPE_DSA);
  //   }
  // }

  function sendPosPing() {
    const state = store.getState();
    const designId = state.designId;
    const hasPosItems = document.querySelector("[data-source]") !== null;
    if (!hasPosItems) {
      return
    }

    designService.designPingPos(designId).then((resp) => {
      if (resp.data.changed) {
        showChangedByPos();
      } else {
        const pending = parseInt(resp.data.pending);
        if (pending > 0) {
          store.dispatch(actions.setPosSyncPendingCount(pending));
        }
      }
    });
  }

  useEffect(() => {
    let pingInterval = setInterval(sendPing, 30 * 1000);
    let posPingInterval = setInterval(sendPosPing, 10 * 1000);
    // let dsaPingInter = setInterval(sendDsaPing, 45 * 1000);
    return () => {
      if (pingInterval != null) clearInterval(pingInterval);
      if (posPingInterval != null) clearInterval(posPingInterval);
      // if (dsaPingInter != null) clearInterval(dsaPingInter);
    }
  }, []);
}
